export default {
	urlAPI: 'https://backend.homologacao.sintufrj.org.br/public/api/',
	urlPublic: 'https://backend.homologacao.sintufrj.org.br/public/',
	urlStorage: 'https://backend.homologacao.sintufrj.org.br/Storage/'

} 


//////////////////
// WEBPACK FOOTER
// ./src/config/config
// module id = 10
// module chunks = 33